import { HEX_292D38, HEX_646A7E, HEX_959EB0, HEX_DCDFE6, HEX_FFFFFF } from '@tanium/colors';
import { Background3, defineColor } from '@tanium/react-theme-definition';

export const ActiveFill = Background3;
export const DateLabelText = defineColor([HEX_292D38, HEX_DCDFE6]);
export const DateValueText = defineColor([HEX_646A7E, HEX_FFFFFF]);
export const LabelText = defineColor([HEX_292D38, HEX_959EB0]);
export const SubtleText = defineColor([HEX_646A7E, HEX_959EB0]);
